import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const resources = {
  en: {
    translation: {
      nav: {
        home: "Home",
        allTools: "All Tools",
        language: "Language",
        theme: "Toggle theme",
      },
      hero: {
        pill: "100% Free • No Sign-up Required",
        title: "Free",
        highlight: "Tools",
        subtitle:
          "A collection of essential tools to help you build, optimize, and maintain your websites. No registration needed.",
        explore: "Explore Tools",
        metaDescription:
          "Free tools to build, optimize, and maintain modern projects. No sign-up required.",
      },
      tools: {
        sectionTitle: "Tools",
        sectionSubtitle:
          "Everything you need to build and optimize your projects.",
        allTitle: "All Tools",
        allSubtitle:
          "Browse the full library of tools available on Peslar.com.",
        useTool: "Use Tool →",
        openTool: "Open Tool →",
        searchPlaceholder: "Search tools...",
        noResults: "No tools found matching your search.",
      },
      toolPage: {
        comingSoon: "Coming soon",
        notFoundTitle: "Tool not found",
        notFoundSubtitle: "Please check the URL or return to the homepage.",
      },
      footer: {
        home: "Home",
        tools: "Tools",
        copyright: "© 2012-{{year}} PESLAR.COM",
      },
      toolList: {
        sitemap: {
          name: "Sitemap Generator",
          description:
            "Create XML sitemaps for your website to improve SEO visibility.",
        },
        meta: {
          name: "Meta Tag Generator",
          description: "Generate optimized meta tags for better sharing.",
        },
        robots: {
          name: "Robots.txt Generator",
          description: "Control how search engines crawl your website.",
        },
        redirects: {
          name: "Redirects Tester",
          description: "Test common redirects for your website.",
        },
        palette: {
          name: "Color Palette Generator",
          description: "Create beautiful palettes with quick copy.",
        },
        qr: {
          name: "QR Code Generator",
          description: "Create QR codes for URLs, text, and more.",
        },
        password: {
          name: "Password Generator",
          description: "Generate strong, secure passwords instantly.",
        },
        json: {
          name: "JSON Formatter & Validator",
          description: "Beautify, minify, and validate JSON instantly.",
        },
        toon: {
          name: "JSON to TOON Converter",
          description: "Convert JSON to TOON and reduce LLM tokens by ~60%.",
        },
        compound: {
          name: "Compound Interest Calculator",
          description: "Calculate compound interest with yearly breakdown.",
        },
        colorConverter: {
          name: "Color Converter",
          description: "Convert colors between HEX, RGB, and HSL formats.",
        },
        colorInverter: {
          name: "Color Inverter",
          description: "Invert a color and instantly copy the result.",
        },
        regex: {
          name: "Regex Tester",
          description:
            "Test regular expression patterns against text with real-time results.",
        },
        timezone: {
          name: "Time Zone Converter",
          description: "Convert times across multiple time zones instantly.",
        },
        wordCounter: {
          name: "Word & Character Counter",
          description:
            "Count words, characters, sentences, and estimate reading time.",
        },
        loremIpsum: {
          name: "Lorem Ipsum Generator",
          description:
            "Generate placeholder text for your designs and mockups.",
        },
        base64: {
          name: "Base64 Encoder/Decoder",
          description:
            "Convert text to/from Base64 — useful for developers and data encoding.",
        },
        uuid: {
          name: "UUID Generator",
          description:
            "Generate UUIDs (GUIDs) for databases, API keys, tokens, and more.",
        },
        businessName: {
          name: "Business Name Generator",
          description:
            "Generate memorable brand names from keywords, tone, and industry.",
        },
        logoCreator: {
          name: "Free Logo Creator",
          description:
            "Create, customize, and export Lucide icons as SVG or PNG instantly.",
        },
        hexagonDragAndDrop: {
          name: "Hexagon Place & Drag-and-Drop",
          description:
            "Drag solid hexagons onto a hex grid and snap them into placeholder slots.",
        },
        textCaseConverter: {
          name: "Text Case Converter",
          description:
            "Convert text to uppercase, lowercase, title case, sentence case, camelCase, snake_case and more.",
        },
        imageToPdf: {
          name: "Image to PDF Converter",
          description:
            "Combine JPG, PNG and WebP images into a single PDF. Runs in your browser, nothing is uploaded.",
        },
      },
      hexagonDragAndDrop: {
        boardTitle: "Board",
        reset: "Reset",
        filledSlots: "{{count}} filled",
        zoomLabel: "Zoom {{zoom}}",
        panZoomHint:
          "Click to place/remove hexes. Drag to pan. Use the scroll wheel or trackpad to zoom. Your board is saved automatically.",
      },
      textCaseConverter: {
        inputLabel: "Your text",
        inputPlaceholder: "Type or paste your text here...",
        outputPlaceholder: "Result will appear here...",
        copy: "Copy",
        clear: "Clear",
        copied: "Copied to clipboard!",
        copyFailed: "Failed to copy.",
        cases: {
          upper: "UPPERCASE",
          lower: "lowercase",
          title: "Title Case",
          sentence: "Sentence case",
          camel: "camelCase",
          pascal: "PascalCase",
          snake: "snake_case",
          kebab: "kebab-case",
          constant: "CONSTANT_CASE",
          alternating: "aLtErNaTiNg cAsE",
          inverse: "iNVERSE cASE",
        },
      },
      imageToPdf: {
        dropTitle: "Click to choose images or drop them here",
        dropHint: "JPG, PNG, WebP, GIF and more. You can add several images.",
        skipped: "Some files were skipped because they are not images.",
        failed: "Could not create the PDF. Try different images.",
        moveUp: "Move up",
        moveDown: "Move down",
        remove: "Remove",
        pageSize: "Page size",
        fit: "Fit to image",
        margin: "Margin",
        marginNone: "None",
        marginSmall: "Small",
        marginBig: "Big",
        create: "Create PDF",
        creating: "Creating...",
        clear: "Clear all",
        privacy: "Your images never leave your device.",
      },
      uuidGenerator: {
        count: "How many?",
        countHint: "1–100",
        format: "Format",
        lowercase: "Lowercase",
        uppercase: "Uppercase",
        braces: "Wrap with { }",
        generate: "Generate",
        copyAll: "Copy all",
        clear: "Clear",
        outputLabel: "UUIDs",
        outputPlaceholder: "Generated UUIDs will appear here.",
        copied: "UUIDs copied to clipboard!",
        copyFailed: "Failed to copy UUIDs.",
      },
      logoCreator: {
        iconLibrary: "Lucide Icons",
        search: "Search icons",
        noResults: "No icons found for that search.",
        preview: "Live Preview",
        zoom: "Zoom",
        rotation: "Rotation",
        output: "Output size",
        customize: "Customize",
        size: "Size",
        stroke: "Stroke width",
        color: "Icon color",
        background: "Background",
        transparent: "Transparent",
        solid: "Solid",
        padding: "Padding",
        export: "Export",
        exportSvg: "Export SVG",
        exportPng: "Export PNG",
        copySvg: "Copy SVG",
        pngPresets: "PNG presets",
        copySuccess: "SVG copied to clipboard.",
        copyFailed: "Copy failed. Try again.",
        pngFailed: "PNG export failed. Please retry.",
        loadError: "Icon library failed to load. Please refresh the page.",
      },
      passwordGenerator: {
        placeholder: "Your password will appear here",
        length: "Length",
        charTypes: "Character Types",
        uppercase: "Uppercase Letters (A-Z)",
        lowercase: "Lowercase Letters (a-z)",
        numbers: "Numbers (0-9)",
        symbols: "Symbols (!@#$%^&*)",
        securityOptions: "Security Options",
        excludeSimilar: "Exclude Similar Characters (i, l, 1, L, o, 0, O)",
        excludeAmbiguous:
          "Exclude Ambiguous Characters ({ } [ ] ( ) / \\ ' \" ` ~ , ; : . < >)",
        excludeExclamation: "Exclude Exclamation Mark (!)",
        generate: "Generate Password",
        saveToHistory: "Save to History (Local Storage)",
        showHistory: "Show History",
        hideHistory: "Hide History",
        history: "History",
        clearHistory: "Clear History",
        noHistory: "No passwords generated yet.",
        copy: "Copy",
        delete: "Delete",
        copied: "Password copied to clipboard!",
        copyFailed: "Failed to copy password.",
        strength: {
          weak: "Weak",
          medium: "Medium",
          strong: "Strong",
        },
      },
      jsonFormatter: {
        inputLabel: "Paste JSON",
        inputPlaceholder: '{ "name": "Peslar" }',
        outputLabel: "Formatted output",
        outputPlaceholder: "Formatted JSON will appear here.",
        beautify: "Beautify",
        minify: "Minify",
        copy: "Copy output",
        clear: "Clear",
        valid: "Valid JSON.",
        invalid: "Invalid JSON.",
        errorPosition: "Line {{line}}, Column {{column}}.",
        copied: "JSON copied to clipboard!",
        copyFailed: "Failed to copy JSON.",
      },
      jsonToToon: {
        inputLabel: "Paste JSON",
        inputPlaceholder: '{ "name": "Peslar" }',
        outputLabel: "TOON output",
        outputPlaceholder: "TOON will appear here.",
        convert: "Convert to TOON",
        copy: "Copy output",
        clear: "Clear",
        valid: "Valid JSON.",
        invalid: "Invalid JSON.",
        errorPosition: "Line {{line}}, Column {{column}}.",
        tokenReduction: "Token reduction: ~{{percent}}%",
        copied: "TOON copied to clipboard!",
        copyFailed: "Failed to copy TOON.",
      },
      businessNameGenerator: {
        keywords: "Keywords",
        keywordsPlaceholder: "coffee, organic, roastery",
        industryLabel: "Industry",
        toneLabel: "Tone",
        formatLabel: "Format",
        countLabel: "How many?",
        includeKeyword: "Include at least one keyword",
        alliteration: "Prefer alliteration",
        useSuffix: "Add a brand suffix (Labs, Studio, Co)",
        generate: "Generate Names",
        copyAll: "Copy All",
        clear: "Clear",
        results: "Results",
        resultCount: "{{count}} names",
        empty: "No names yet. Generate to get ideas.",
        copy: "Copy",
        copied: "Copied to clipboard!",
        copyFailed: "Failed to copy.",
        industry: {
          general: "General",
          tech: "Tech",
          finance: "Finance",
          health: "Health",
          food: "Food & Beverage",
          fashion: "Fashion",
          realEstate: "Real Estate",
          marketing: "Marketing",
          education: "Education",
          travel: "Travel",
          ecommerce: "E-commerce",
          fitness: "Fitness",
          services: "Services",
        },
        tone: {
          modern: "Modern",
          playful: "Playful",
          premium: "Premium",
          minimal: "Minimal",
          classic: "Classic",
        },
        format: {
          oneWord: "One word",
          twoWord: "Two words",
          hyphenated: "Hyphenated",
          suffix: "Brand + suffix",
          invented: "Invented",
        },
      },
      qrGenerator: {
        tabs: {
          generate: "Generate QR Code",
          scan: "Scan QR Code",
        },
        inputLabel: "Enter text or URL:",
        inputPlaceholder: "https://example.com",
        generate: "Generate QR Code",
        download: "Download",
        copyText: "Copy Text",
        copyLink: "Copy Share Link",
        linkCopied: "Share link copied to clipboard!",
        qrAlt: "Generated QR code",
        qrPlaceholder: "Your QR code will appear here.",
        startCamera: "Start Camera",
        stopCamera: "Stop Camera",
        switchCamera: "Switch Camera",
        scanPlaceholder: "Camera preview will appear here.",
        scanResultLabel: "Scanned text",
        scanNoResult: "No QR code detected yet.",
        copyResult: "Copy Result",
        copied: "Copied to clipboard!",
        copyFailed: "Failed to copy.",
        generateFailed: "Failed to generate QR code.",
        cameraError: "Unable to access the camera.",
        cameraUnsupported: "Camera access is not supported in this browser.",
      },
      paletteGenerator: {
        generate: "Generate palette",
        hint: "Lock any color to keep it on re-roll.",
        copy: "Copy hex",
        lock: "Lock",
        unlock: "Unlock",
        copied: "Color copied to clipboard!",
        copyFailed: "Failed to copy color.",
      },
      robotsGenerator: {
        userAgentLabel: "User agent",
        customAgentPlaceholder: "Custom user agent",
        userAgents: {
          all: "All bots (*)",
          google: "Googlebot",
          bing: "Bingbot",
          duckduck: "DuckDuckBot",
          yandex: "YandexBot",
          baidu: "Baiduspider",
          custom: "Custom",
        },
        allowLabel: "Allow paths",
        disallowLabel: "Disallow paths",
        addAllow: "Add allow",
        addDisallow: "Add disallow",
        allowPlaceholder: "/public",
        disallowPlaceholder: "/private",
        removePath: "Remove path",
        crawlDelayLabel: "Crawl-delay (seconds)",
        crawlDelayPlaceholder: "e.g. 10",
        sitemapLabel: "Sitemap URL",
        sitemapPlaceholder: "https://example.com/sitemap.xml",
        previewLabel: "Robots.txt preview",
        copy: "Copy",
        download: "Download",
        copied: "Robots.txt copied to clipboard!",
        copyFailed: "Failed to copy robots.txt.",
      },
      redirectsTester: {
        inputLabel: "Site or URL",
        inputPlaceholder: "example.com or https://example.com",
        inputHint: "Enter a domain or full URL. We'll test common redirects.",
        runTests: "Run tests",
        running: "Running...",
        copyResults: "Copy results",
        emptyState: "Run a test to see redirect results.",
        invalidUrl: "Enter a valid domain or URL.",
        fetchFailed: "Request failed.",
        corsNote: "Some servers block browser checks (CORS).",
        opaqueResponse: "Blocked by CORS. Use Open or Copy curl.",
        proxyFailed: "Proxy request failed.",
        openUrl: "Open URL",
        copyCurl: "Copy curl",
        curlCopied: "curl command copied!",
        curlCopyFailed: "Failed to copy curl command.",
        tests: {
          asEntered: "As entered",
          http: "HTTP version",
          https: "HTTPS version",
          www: "WWW version",
          nonWww: "Non-WWW version",
          trailingSlash: "Toggle trailing slash",
          indexHtml: "Add index.html",
        },
        requestUrl: "Request URL",
        finalUrl: "Final URL",
        redirectedYes: "Redirected",
        redirectedNo: "No redirect",
        chainLabel: "Chain",
        chainUnknown: "Unknown",
        noFinalUrl: "Unavailable",
        unknownStatus: "Unknown",
        noStatus: "No status",
        copied: "Results copied to clipboard!",
        copyFailed: "Failed to copy results.",
      },
      compoundCalculator: {
        principalLabel: "Initial Investment",
        rateLabel: "Annual Interest Rate",
        yearsLabel: "Investment Period (Years)",
        frequencyLabel: "Compounding Frequency",
        frequencies: {
          annually: "Annually",
          semiannually: "Semi-annually",
          quarterly: "Quarterly",
          monthly: "Monthly",
        },
        finalAmount: "Final Amount",
        totalInterest: "Total Interest Earned",
        totalPrincipal: "Total Principal",
        breakdownTitle: "Year by Year Breakdown",
        placeholder: "Enter values to calculate compound interest",
        table: {
          year: "Year",
          startBalance: "Start Balance",
          interest: "Interest",
          endBalance: "End Balance",
        },
      },
      colorConverter: {
        hex: "HEX",
        rgb: "RGB",
        hsl: "HSL",
        preview: "Color Preview",
        copy: "Copy {{format}}",
        copied: "{{format}} copied to clipboard!",
        copyFailed: "Failed to copy.",
      },
      colorInverter: {
        inputLabel: "Input color (HEX)",
        inputPlaceholder: "#22D3EE",
        original: "Original",
        inverted: "Inverted",
        hex: "HEX",
        rgb: "RGB",
        copyHex: "Copy HEX",
        copyRgb: "Copy RGB",
        copiedHex: "HEX copied to clipboard!",
        copiedRgb: "RGB copied to clipboard!",
        copyFailed: "Failed to copy.",
        invalidHex: "Enter a valid HEX color (e.g. #22D3EE).",
      },
      regexTester: {
        patternLabel: "Regular Expression Pattern",
        patternPlaceholder: "Enter your regex pattern (e.g., [a-z]+",
        flagsLabel: "Flags",
        textLabel: "Test Text",
        textPlaceholder: "Enter text to test against your pattern...",
        resultsLabel: "Results",
        copy: "Copy Pattern",
        clear: "Clear All",
        copied: "Pattern copied to clipboard!",
        copyFailed: "Failed to copy pattern.",
        enterPattern: "Enter a pattern to test",
        invalid: "Invalid regex",
        noMatchesFound: "No matches found",
        noMatches: "No matches found in the provided text.",
        matchesFound: "Found {{count}} match(es)",
        matches: "Matches",
        position: "Position: {{index}}",
        groups: "Capture Groups",
        namedGroups: "Named Groups",
        emptyState: "Enter a pattern and text to see results",
        flags: {
          global: "Global",
          ignoreCase: "Ignore Case",
          multiline: "Multiline",
          dotAll: "Dot All",
          unicode: "Unicode",
          sticky: "Sticky",
        },
      },
      timezoneConverter: {
        sourceTime: "Source Time",
        useCurrentTime: "Use Current Time",
        addTimezone: "Add Time Zone",
        searchPlaceholder: "Search time zones...",
        popularZones: "Popular",
        noZones: "Add time zones to see conversions.",
        remove: "Remove",
        copy: "Copy",
        copied: "Time copied to clipboard!",
        copyFailed: "Failed to copy.",
      },
      wordCounter: {
        placeholder: "Type or paste your text here...",
        words: "Words",
        characters: "Characters",
        charactersNoSpaces: "Characters (no spaces)",
        sentences: "Sentences",
        paragraphs: "Paragraphs",
        readingTime: "Reading Time",
        minutes: "min",
        clear: "Clear",
        copyStats: "Copy Stats",
        copied: "Stats copied to clipboard!",
        copyFailed: "Failed to copy.",
      },
      loremIpsumGenerator: {
        outputType: "Output Type",
        paragraphs: "Paragraphs",
        sentences: "Sentences",
        words: "Words",
        quantity: "Quantity",
        startWithLorem: 'Start with "Lorem ipsum..."',
        generate: "Generate",
        output: "Generated Text",
        outputPlaceholder: "Your Lorem Ipsum text will appear here...",
        copy: "Copy",
        copied: "Text copied to clipboard!",
        copyFailed: "Failed to copy.",
      },
      base64Encoder: {
        encode: "Encode",
        decode: "Decode",
        inputLabel: "Input",
        inputPlaceholderEncode: "Enter text to encode...",
        inputPlaceholderDecode: "Enter Base64 to decode...",
        outputLabel: "Output",
        outputPlaceholder: "Result will appear here...",
        copy: "Copy",
        swap: "Swap",
        clear: "Clear",
        copied: "Copied to clipboard!",
        copyFailed: "Failed to copy.",
        invalidBase64: "Invalid Base64 input",
      },
      sitemapGenerator: {
        crawlLabel: "Crawl Website",
        crawlHint:
          "Enter a URL to automatically discover all pages on the website.",
        crawlPlaceholder: "https://example.com",
        crawl: "Crawl",
        crawling: "Crawling...",
        crawlFailed: "Failed to crawl the website. Please try again.",
        noUrlsFound: "No pages found on this website.",
        optionsLabel: "Options",
        includeLastmod: "Include last modified date",
        includeChangefreq: "Include change frequency",
        includePriority: "Include priority",
        urlsLabel: "URLs",
        urlCount: "{{count}} URL(s)",
        addUrl: "Add URL",
        removeUrl: "Remove URL",
        urlLabel: "URL",
        urlPlaceholder: "https://example.com/page",
        lastmodLabel: "Last modified",
        changefreqLabel: "Change frequency",
        priorityLabel: "Priority",
        changefreq: {
          always: "Always",
          hourly: "Hourly",
          daily: "Daily",
          weekly: "Weekly",
          monthly: "Monthly",
          yearly: "Yearly",
          never: "Never",
        },
        previewLabel: "Sitemap XML preview",
        copy: "Copy",
        download: "Download",
        copied: "Sitemap copied to clipboard!",
        copyFailed: "Failed to copy sitemap.",
        emptyPreview: "Add at least one URL to generate the sitemap.",
      },
    },
  },
  ro: {
    translation: {
      nav: {
        home: "Acasă",
        allTools: "Toate uneltele",
        language: "Limbă",
        theme: "Comută tema",
      },
      hero: {
        pill: "100% Gratuit • Fără cont necesar",
        title: "Instrumente",
        highlight: "Gratuite",
        subtitle:
          "O colecție de unelte esențiale pentru a construi, optimiza și menține site-urile tale. Nu este nevoie de înregistrare.",
        explore: "Vezi uneltele",
        metaDescription:
          "Instrumente gratuite pentru a construi, optimiza și întreține proiecte moderne. Fără înregistrare.",
      },
      tools: {
        sectionTitle: "Unelte gratuite",
        sectionSubtitle:
          "Tot ce ai nevoie pentru a construi și optimiza proiecte web.",
        allTitle: "Toate uneltele",
        allSubtitle:
          "Răsfoiește întreaga bibliotecă de unelte disponibile pe Peslar.com.",
        useTool: "Deschide →",
        openTool: "Deschide →",
        searchPlaceholder: "Caută unelte...",
        noResults: "Nu s-au găsit unelte care să corespundă căutării.",
      },
      toolPage: {
        comingSoon: "În curând",
        notFoundTitle: "Unealta nu a fost găsită",
        notFoundSubtitle: "Verifică URL-ul sau revino pe pagina principală.",
      },
      footer: {
        home: "Acasă",
        tools: "Unelte",
        copyright: "© 2012-{{year}} PESLAR.COM",
      },
      toolList: {
        sitemap: {
          name: "Generator sitemap",
          description:
            "Creează sitemap-uri XML pentru a îmbunătăți vizibilitatea SEO.",
        },
        meta: {
          name: "Generator meta tag",
          description: "Generează meta tag-uri optimizate pentru distribuire.",
        },
        robots: {
          name: "Generator robots.txt",
          description:
            "Controlează modul în care motoarele de căutare accesează site-ul.",
        },
        redirects: {
          name: "Tester redirecturi",
          description: "Testează redirecturile comune pentru site-ul tău.",
        },
        palette: {
          name: "Generator palete de culori",
          description: "Creează palete frumoase cu copiere rapidă.",
        },
        qr: {
          name: "Generator cod QR",
          description: "Creează coduri QR pentru URL-uri, text și altele.",
        },
        password: {
          name: "Generator parole",
          description: "Generează instant parole puternice și sigure.",
        },
        json: {
          name: "Formator & validator JSON",
          description: "Formatează, minifică și validează JSON instant.",
        },
        toon: {
          name: "Convertor JSON în TOON",
          description: "Transformă JSON în TOON și reduce tokenii LLM cu ~60%.",
        },
        compound: {
          name: "Calculator dobândă compusă",
          description: "Calculează dobânda compusă cu detaliere anuală.",
        },
        colorConverter: {
          name: "Convertor de culori",
          description: "Convertește culori între formatele HEX, RGB și HSL.",
        },
        colorInverter: {
          name: "Inversor de culori",
          description: "Inversează o culoare și copiază instant rezultatul.",
        },
        regex: {
          name: "Tester Regex",
          description:
            "Testează expresii regulate pe text cu rezultate în timp real.",
        },
        timezone: {
          name: "Convertor Fus Orar",
          description: "Convertește ore între mai multe fusuri orare instant.",
        },
        wordCounter: {
          name: "Contor Cuvinte & Caractere",
          description:
            "Numără cuvinte, caractere, propoziții și estimează timpul de citire.",
        },
        loremIpsum: {
          name: "Generator Lorem Ipsum",
          description:
            "Generează text substituent pentru designuri și machete.",
        },
        base64: {
          name: "Codificator/Decodificator Base64",
          description:
            "Convertește text în/din Base64 — util pentru dezvoltatori și codificarea datelor.",
        },
        uuid: {
          name: "Generator UUID",
          description:
            "Generează UUID-uri (GUID-uri) pentru baze de date, chei API, token-uri și altele.",
        },
        businessName: {
          name: "Generator de nume pentru afaceri",
          description:
            "Generează nume memorabile pe baza cuvintelor cheie, tonului și industriei.",
        },
        logoCreator: {
          name: "Creator logo gratuit",
          description:
            "Creează, personalizează și exportă pictograme Lucide ca SVG sau PNG instant.",
        },
        hexagonDragAndDrop: {
          name: "Plasare hexagoane & drag-and-drop",
          description:
            "Trage hexagoane pline pe o grilă și fixează-le în pozițiile marcate.",
        },
        textCaseConverter: {
          name: "Convertor Majuscule/Minuscule",
          description:
            "Convertește textul în majuscule, minuscule, Title Case, propoziție, camelCase, snake_case și altele.",
        },
        imageToPdf: {
          name: "Convertor Imagine în PDF",
          description:
            "Combină imagini JPG, PNG și WebP într-un singur PDF. Rulează în browser, nu se încarcă nimic.",
        },
      },
      hexagonDragAndDrop: {
        boardTitle: "Tablă",
        reset: "Resetare",
        filledSlots: "{{count}} ocupate",
        zoomLabel: "Zoom {{zoom}}",
        panZoomHint:
          "Click pentru a plasa/șterge hexagoane. Trage pentru pan. Folosește scroll-ul sau trackpad-ul pentru zoom. Tabla se salvează automat.",
      },
      textCaseConverter: {
        inputLabel: "Textul tău",
        inputPlaceholder: "Scrie sau lipește textul aici...",
        outputPlaceholder: "Rezultatul va apărea aici...",
        copy: "Copiază",
        clear: "Șterge",
        copied: "Copiat în clipboard!",
        copyFailed: "Copierea a eșuat.",
        cases: {
          upper: "UPPERCASE",
          lower: "lowercase",
          title: "Title Case",
          sentence: "Propoziție",
          camel: "camelCase",
          pascal: "PascalCase",
          snake: "snake_case",
          kebab: "kebab-case",
          constant: "CONSTANT_CASE",
          alternating: "aLtErNaTiNg cAsE",
          inverse: "iNVERSE cASE",
        },
      },
      imageToPdf: {
        dropTitle: "Click pentru a alege imagini sau trage-le aici",
        dropHint: "JPG, PNG, WebP, GIF și altele. Poți adăuga mai multe imagini.",
        skipped: "Unele fișiere au fost ignorate pentru că nu sunt imagini.",
        failed: "PDF-ul nu a putut fi creat. Încearcă alte imagini.",
        moveUp: "Mută sus",
        moveDown: "Mută jos",
        remove: "Elimină",
        pageSize: "Dimensiune pagină",
        fit: "Potrivit imaginii",
        margin: "Margine",
        marginNone: "Fără",
        marginSmall: "Mică",
        marginBig: "Mare",
        create: "Creează PDF",
        creating: "Se creează...",
        clear: "Șterge tot",
        privacy: "Imaginile tale nu părăsesc dispozitivul.",
      },
      uuidGenerator: {
        count: "Câte?",
        countHint: "1–100",
        format: "Format",
        lowercase: "Litere mici",
        uppercase: "Litere mari",
        braces: "Încadrează cu { }",
        generate: "Generează",
        copyAll: "Copiază tot",
        clear: "Golește",
        outputLabel: "UUID-uri",
        outputPlaceholder: "UUID-urile generate vor apărea aici.",
        copied: "UUID-urile au fost copiate!",
        copyFailed: "Copierea UUID-urilor a eșuat.",
      },
      logoCreator: {
        iconLibrary: "Pictograme Lucide",
        search: "Caută pictograme",
        noResults: "Nu am găsit pictograme pentru căutare.",
        preview: "Previzualizare live",
        zoom: "Zoom",
        rotation: "Rotație",
        output: "Dimensiune finală",
        customize: "Personalizează",
        size: "Dimensiune",
        stroke: "Grosime contur",
        color: "Culoare pictogramă",
        background: "Fundal",
        transparent: "Transparent",
        solid: "Solid",
        padding: "Spațiere",
        export: "Export",
        exportSvg: "Exportă SVG",
        exportPng: "Exportă PNG",
        copySvg: "Copiază SVG",
        pngPresets: "Preseturi PNG",
        copySuccess: "SVG copiat în clipboard.",
        copyFailed: "Copiere eșuată. Încearcă din nou.",
        pngFailed: "Export PNG eșuat. Te rog reîncearcă.",
        loadError:
          "Biblioteca de pictograme nu a putut fi încărcată. Reîmprospătează pagina.",
      },
      passwordGenerator: {
        placeholder: "Parola va apărea aici",
        length: "Lungime",
        charTypes: "Tipuri de caractere",
        uppercase: "Litere mari (A-Z)",
        lowercase: "Litere mici (a-z)",
        numbers: "Numere (0-9)",
        symbols: "Simboluri (!@#$%^&*)",
        securityOptions: "Opțiuni de securitate",
        excludeSimilar: "Exclude caractere similare (i, l, 1, L, o, 0, O)",
        excludeAmbiguous:
          "Exclude caractere ambigue ({ } [ ] ( ) / \\ ' \" ` ~ , ; : . < >)",
        excludeExclamation: "Exclude semnul exclamării (!)",
        generate: "Generează parolă",
        saveToHistory: "Salvează în istoric (Local Storage)",
        showHistory: "Arată istoricul",
        hideHistory: "Ascunde istoricul",
        history: "Istoric",
        clearHistory: "Șterge istoricul",
        noHistory: "Nicio parolă generată încă.",
        copy: "Copiază",
        delete: "Șterge",
        copied: "Parola a fost copiată!",
        copyFailed: "Copierea parolei a eșuat.",
        strength: {
          weak: "Slabă",
          medium: "Medie",
          strong: "Puternică",
        },
      },
      jsonFormatter: {
        inputLabel: "Lipește JSON",
        inputPlaceholder: '{ "nume": "Peslar" }',
        outputLabel: "Rezultat formatat",
        outputPlaceholder: "JSON-ul formatat va apărea aici.",
        beautify: "Formatează",
        minify: "Minifică",
        copy: "Copiază rezultatul",
        clear: "Golește",
        valid: "JSON valid.",
        invalid: "JSON invalid.",
        errorPosition: "Linia {{line}}, coloana {{column}}.",
        copied: "JSON copiat în clipboard!",
        copyFailed: "Copierea JSON-ului a eșuat.",
      },
      jsonToToon: {
        inputLabel: "Lipește JSON",
        inputPlaceholder: '{ "nume": "Peslar" }',
        outputLabel: "Rezultat TOON",
        outputPlaceholder: "TOON va apărea aici.",
        convert: "Convertește în TOON",
        copy: "Copiază rezultatul",
        clear: "Golește",
        valid: "JSON valid.",
        invalid: "JSON invalid.",
        errorPosition: "Linia {{line}}, coloana {{column}}.",
        tokenReduction: "Reducere tokeni: ~{{percent}}%",
        copied: "TOON copiat în clipboard!",
        copyFailed: "Copierea TOON a eșuat.",
      },
      businessNameGenerator: {
        keywords: "Cuvinte cheie",
        keywordsPlaceholder: "cafea, organic, prăjitorie",
        industryLabel: "Industrie",
        toneLabel: "Ton",
        formatLabel: "Format",
        countLabel: "Câte?",
        includeKeyword: "Include cel puțin un cuvânt cheie",
        alliteration: "Preferă aliterația",
        useSuffix: "Adaugă un sufix de brand (Labs, Studio, Co)",
        generate: "Generează nume",
        copyAll: "Copiază tot",
        clear: "Golește",
        results: "Rezultate",
        resultCount: "{{count}} nume",
        empty: "Nicio sugestie încă. Generează pentru idei.",
        copy: "Copiază",
        copied: "Copiat în clipboard!",
        copyFailed: "Copierea a eșuat.",
        industry: {
          general: "General",
          tech: "Tehnologie",
          finance: "Finanțe",
          health: "Sănătate",
          food: "Food & Beverage",
          fashion: "Modă",
          realEstate: "Imobiliare",
          marketing: "Marketing",
          education: "Educație",
          travel: "Turism",
          ecommerce: "E-commerce",
          fitness: "Fitness",
          services: "Servicii",
        },
        tone: {
          modern: "Modern",
          playful: "Jucăuș",
          premium: "Premium",
          minimal: "Minimal",
          classic: "Clasic",
        },
        format: {
          oneWord: "Un cuvânt",
          twoWord: "Două cuvinte",
          hyphenated: "Cu cratimă",
          suffix: "Brand + sufix",
          invented: "Inventat",
        },
      },
      qrGenerator: {
        tabs: {
          generate: "Generează cod QR",
          scan: "Scanează cod QR",
        },
        inputLabel: "Introdu text sau URL:",
        inputPlaceholder: "https://exemplu.ro",
        generate: "Generează cod QR",
        download: "Descarcă",
        copyText: "Copiază textul",
        copyLink: "Copiază linkul de partajare",
        linkCopied: "Linkul de partajare a fost copiat!",
        qrAlt: "Cod QR generat",
        qrPlaceholder: "Codul tău QR va apărea aici.",
        startCamera: "Pornește camera",
        stopCamera: "Oprește camera",
        switchCamera: "Schimbă camera",
        scanPlaceholder: "Previzualizarea camerei va apărea aici.",
        scanResultLabel: "Text scanat",
        scanNoResult: "Nu s-a detectat încă niciun cod QR.",
        copyResult: "Copiază rezultatul",
        copied: "Copiat în clipboard!",
        copyFailed: "Copierea a eșuat.",
        generateFailed: "Generarea codului QR a eșuat.",
        cameraError: "Nu s-a putut accesa camera.",
        cameraUnsupported:
          "Accesul la cameră nu este suportat în acest browser.",
      },
      paletteGenerator: {
        generate: "Generează paletă",
        hint: "Blochează orice culoare ca să rămână la reîmprospătare.",
        copy: "Copiază hex",
        lock: "Blochează",
        unlock: "Deblochează",
        copied: "Culoarea a fost copiată!",
        copyFailed: "Nu s-a putut copia culoarea.",
      },
      robotsGenerator: {
        userAgentLabel: "User agent",
        customAgentPlaceholder: "User agent personalizat",
        userAgents: {
          all: "Toți roboții (*)",
          google: "Googlebot",
          bing: "Bingbot",
          duckduck: "DuckDuckBot",
          yandex: "YandexBot",
          baidu: "Baiduspider",
          custom: "Personalizat",
        },
        allowLabel: "Căi permise",
        disallowLabel: "Căi restricționate",
        addAllow: "Adaugă allow",
        addDisallow: "Adaugă disallow",
        allowPlaceholder: "/public",
        disallowPlaceholder: "/privat",
        removePath: "Elimină calea",
        crawlDelayLabel: "Crawl-delay (secunde)",
        crawlDelayPlaceholder: "ex: 10",
        sitemapLabel: "URL sitemap",
        sitemapPlaceholder: "https://exemplu.ro/sitemap.xml",
        previewLabel: "Previzualizare robots.txt",
        copy: "Copiază",
        download: "Descarcă",
        copied: "Robots.txt a fost copiat!",
        copyFailed: "Copierea a eșuat.",
      },
      redirectsTester: {
        inputLabel: "Site sau URL",
        inputPlaceholder: "exemplu.ro sau https://exemplu.ro",
        inputHint:
          "Introdu un domeniu sau un URL complet. Testăm redirecturi uzuale.",
        runTests: "Rulează teste",
        running: "Se rulează...",
        copyResults: "Copiază rezultate",
        emptyState: "Rulează un test pentru a vedea rezultatele.",
        invalidUrl: "Introdu un domeniu sau URL valid.",
        fetchFailed: "Cererea a eșuat.",
        corsNote: "Unele site-uri blochează testarea din browser (CORS).",
        opaqueResponse: "Blocat de CORS. Folosește Deschide sau Copiază curl.",
        proxyFailed: "Cererea către proxy a eșuat.",
        openUrl: "Deschide URL",
        copyCurl: "Copiază curl",
        curlCopied: "Comanda curl a fost copiată!",
        curlCopyFailed: "Copierea comenzii curl a eșuat.",
        tests: {
          asEntered: "Așa cum este",
          http: "Versiune HTTP",
          https: "Versiune HTTPS",
          www: "Versiune WWW",
          nonWww: "Versiune fără WWW",
          trailingSlash: "Comută slash final",
          indexHtml: "Adaugă index.html",
        },
        requestUrl: "URL cerere",
        finalUrl: "URL final",
        redirectedYes: "Redirectat",
        redirectedNo: "Fără redirect",
        chainLabel: "Lanț",
        chainUnknown: "Necunoscut",
        noFinalUrl: "Indisponibil",
        unknownStatus: "Necunoscut",
        noStatus: "Fără status",
        copied: "Rezultatele au fost copiate!",
        copyFailed: "Copierea a eșuat.",
      },
      compoundCalculator: {
        principalLabel: "Investiție inițială",
        rateLabel: "Rată dobândă anuală",
        yearsLabel: "Perioada investiției (ani)",
        frequencyLabel: "Frecvența capitalizării",
        frequencies: {
          annually: "Anual",
          semiannually: "Semestrial",
          quarterly: "Trimestrial",
          monthly: "Lunar",
        },
        finalAmount: "Sumă finală",
        totalInterest: "Dobândă totală câștigată",
        totalPrincipal: "Principal total",
        breakdownTitle: "Detaliere anuală",
        placeholder: "Introdu valorile pentru a calcula dobânda compusă",
        table: {
          year: "Anul",
          startBalance: "Sold inițial",
          interest: "Dobândă",
          endBalance: "Sold final",
        },
      },
      colorConverter: {
        hex: "HEX",
        rgb: "RGB",
        hsl: "HSL",
        preview: "Previzualizare culoare",
        copy: "Copiază {{format}}",
        copied: "{{format}} a fost copiat!",
        copyFailed: "Copierea a eșuat.",
      },
      colorInverter: {
        inputLabel: "Culoare de intrare (HEX)",
        inputPlaceholder: "#22D3EE",
        original: "Original",
        inverted: "Inversat",
        hex: "HEX",
        rgb: "RGB",
        copyHex: "Copiază HEX",
        copyRgb: "Copiază RGB",
        copiedHex: "HEX copiat în clipboard!",
        copiedRgb: "RGB copiat în clipboard!",
        copyFailed: "Copierea a eșuat.",
        invalidHex: "Introdu o culoare HEX validă (ex: #22D3EE).",
      },
      regexTester: {
        patternLabel: "Pattern Expresie Regulată",
        patternPlaceholder: "Introdu pattern-ul regex (ex: [a-z]+",
        flagsLabel: "Flag-uri",
        textLabel: "Text de Test",
        textPlaceholder: "Introdu textul pentru a testa pattern-ul...",
        resultsLabel: "Rezultate",
        copy: "Copiază Pattern",
        clear: "Golește Tot",
        copied: "Pattern copiat în clipboard!",
        copyFailed: "Copierea pattern-ului a eșuat.",
        enterPattern: "Introdu un pattern pentru a testa",
        invalid: "Regex invalid",
        noMatchesFound: "Nu s-au găsit potriviri",
        noMatches: "Nu s-au găsit potriviri în textul furnizat.",
        matchesFound: "S-au găsit {{count}} potriviri",
        matches: "Potriviri",
        position: "Poziție: {{index}}",
        groups: "Grupuri de Captură",
        namedGroups: "Grupuri Numite",
        emptyState: "Introdu un pattern și text pentru a vedea rezultatele",
        flags: {
          global: "Global",
          ignoreCase: "Ignoră Majusculele",
          multiline: "Multilinie",
          dotAll: "Dot All",
          unicode: "Unicode",
          sticky: "Sticky",
        },
      },
      timezoneConverter: {
        sourceTime: "Ora Sursă",
        useCurrentTime: "Folosește Ora Curentă",
        addTimezone: "Adaugă Fus Orar",
        searchPlaceholder: "Caută fusuri orare...",
        popularZones: "Populare",
        noZones: "Adaugă fusuri orare pentru a vedea conversiile.",
        remove: "Elimină",
        copy: "Copiază",
        copied: "Ora a fost copiată!",
        copyFailed: "Copierea a eșuat.",
      },
      wordCounter: {
        placeholder: "Scrie sau lipește textul aici...",
        words: "Cuvinte",
        characters: "Caractere",
        charactersNoSpaces: "Caractere (fără spații)",
        sentences: "Propoziții",
        paragraphs: "Paragrafe",
        readingTime: "Timp de Citire",
        minutes: "min",
        clear: "Golește",
        copyStats: "Copiază Statisticile",
        copied: "Statisticile au fost copiate!",
        copyFailed: "Copierea a eșuat.",
      },
      loremIpsumGenerator: {
        outputType: "Tip Output",
        paragraphs: "Paragrafe",
        sentences: "Propoziții",
        words: "Cuvinte",
        quantity: "Cantitate",
        startWithLorem: 'Începe cu "Lorem ipsum..."',
        generate: "Generează",
        output: "Text Generat",
        outputPlaceholder: "Textul Lorem Ipsum va apărea aici...",
        copy: "Copiază",
        copied: "Textul a fost copiat!",
        copyFailed: "Copierea a eșuat.",
      },
      base64Encoder: {
        encode: "Codifică",
        decode: "Decodifică",
        inputLabel: "Intrare",
        inputPlaceholderEncode: "Introdu textul de codificat...",
        inputPlaceholderDecode: "Introdu Base64 de decodificat...",
        outputLabel: "Ieșire",
        outputPlaceholder: "Rezultatul va apărea aici...",
        copy: "Copiază",
        swap: "Inversează",
        clear: "Golește",
        copied: "Copiat în clipboard!",
        copyFailed: "Copierea a eșuat.",
        invalidBase64: "Base64 invalid",
      },
      sitemapGenerator: {
        crawlLabel: "Scanează site-ul",
        crawlHint:
          "Introdu un URL pentru a descoperi automat toate paginile site-ului.",
        crawlPlaceholder: "https://exemplu.ro",
        crawl: "Scanează",
        crawling: "Se scanează...",
        crawlFailed: "Scanarea site-ului a eșuat. Te rog încearcă din nou.",
        noUrlsFound: "Nu s-au găsit pagini pe acest site.",
        optionsLabel: "Opțiuni",
        includeLastmod: "Include data ultimei modificări",
        includeChangefreq: "Include frecvența modificărilor",
        includePriority: "Include prioritatea",
        urlsLabel: "URL-uri",
        urlCount: "{{count}} URL(-uri)",
        addUrl: "Adaugă URL",
        removeUrl: "Elimină URL",
        urlLabel: "URL",
        urlPlaceholder: "https://exemplu.ro/pagina",
        lastmodLabel: "Ultima modificare",
        changefreqLabel: "Frecvența modificărilor",
        priorityLabel: "Prioritate",
        changefreq: {
          always: "Întotdeauna",
          hourly: "Orar",
          daily: "Zilnic",
          weekly: "Săptămânal",
          monthly: "Lunar",
          yearly: "Anual",
          never: "Niciodată",
        },
        previewLabel: "Previzualizare sitemap XML",
        copy: "Copiază",
        download: "Descarcă",
        copied: "Sitemap-ul a fost copiat!",
        copyFailed: "Copierea sitemap-ului a eșuat.",
        emptyPreview: "Adaugă cel puțin un URL pentru a genera sitemap-ul.",
      },
    },
  },
};

const getInitialLanguage = () => {
  if (typeof window === "undefined") {
    return "en";
  }

  const stored = window.localStorage.getItem("peslarLanguage");
  if (stored) {
    return stored;
  }

  const browserLanguage = window.navigator.language.split("-")[0];
  return browserLanguage === "ro" ? "ro" : "en";
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

if (typeof window !== "undefined") {
  document.documentElement.lang = i18n.language;
}

i18n.on("languageChanged", (lang) => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem("peslarLanguage", lang);
    document.documentElement.lang = lang;
  }
});

export default i18n;
